export default "__VITE_ASSET__BL0gwvn8__"